import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { fetchRecordList } from '@/lib/service';

export default function useUnFollowPremium() {
  const { isLogin } = useUserProvider();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!isLogin) {
      setList([]);
    } else {
      fetchRecordList().then((res: any) => {
        setList(res?.data || []);
      });
    }
  }, [isLogin]);

  return {
    isPremium: !!(isLogin && list?.length),
  };
}
